import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { AuthService } from '../../services/authService';
import { UserMessageService } from '../../services/userMessageService';
import { CaseStudyWhiteLabelAdminAPI } from '../../services/wladmin/caseStudyWhiteLabelAdminAPI';
import { BackgroundMusicAPI } from '../../services/backgroundMusicAPI';
import {CaseStudyBase} from '../base/caseStudy';
import { FontAPI } from '../../services/fontAPI';
import { AccountWhiteLabelAdminAPI } from '../../services/wladmin/accountWhiteLabelAdminAPI';
import { EnvironmentService } from '../../services/environmentService';

@inject(AuthService, UserMessageService, Router, BackgroundMusicAPI, FontAPI, AccountWhiteLabelAdminAPI, CaseStudyWhiteLabelAdminAPI, EnvironmentService)
export class VideoDetails extends CaseStudyBase {
    constructor(authService, userMessageService, router, bgMusicApi, fontApi, accountApi, api, envService) {
        super(authService, userMessageService, router, bgMusicApi, fontApi, accountApi, "api/wladmin", api, envService, true);
        this.fileBase = '';
        this.email = null;

    }

    activate(params, route) {

        super.activate(params, route);
        if(!params.id && params.account_owner_id) {
            this.account_owner_user_id = params.account_owner_id;
        }

  
        this.captureOverride_files = [];
        
        this.captureOverride_files = [];
    }

    reset() {
       

        this.accountApi.getUserData(
            this.account_owner_user_id,  
            this.authService.getUser().token, 
            (userData) => {
                this.account_org_phone = userData.account.org_phone;
                this.account_org_email = userData.account.org_email;
                this.account_website = userData.account.website;
                super.reset();
            }, 
            this.saveLoadError.bind(this));
    }

    setData(data) {
        super.setData(data);

        this.accountApi.getUserData(
            this.account_owner_user_id,  
            this.authService.getUser().token, 
            (userData) => {
                this.account_org_phone = userData.account.org_phone;
                this.account_org_email = userData.account.org_email;
                this.account_website = userData.account.website;
                this.email = userData.user.email;
                this.user_email=userData.user.email;
                this.user_name=userData.user.first_name+' '+userData.user.last_name;
                

            }, 
            this.saveLoadError.bind(this));

        this.capture_override_1 = data.capture_override_1;
        this.capture_override_2 = data.capture_override_2;
        this.capture_override_3 = data.capture_override_3;

      
    }
    openUserDetail(){
        this.router.navigate("#/wladmin/user/"+this.account_owner_user_id);
    }

    reproduce(setReady = false) {
        this.saving = true;
        var data = this.getData();
        data.set_ready = setReady;
        this.api.reproduce(
            data,
            (this.cta_files && this.cta_files.length > 0 && this.showCTAUpload ? this.cta_files[0] : null),
            this.authService.getUser().token,
            this.saveLoadSuccess.bind(this),
            this.saveLoadError.bind(this));
    }


    uploadCaptureOverride(num) {
        if (this.captureOverride_files[num - 1] && this.captureOverride_files[num - 1].length > 0) {
            this.saving = true;
            this.api.saveCaptureOverride(this.id, num,
                this.captureOverride_files[num - 1][0],
                this.authService.getUser().token,
                () => {this.overrideCaptureChanged(num, true)},
                (msg) => {});

                //  this.userMessageService.setUserError("user", "upload capture")});

                //  this.userMessageService.setUserError("user", msg)});

        }
    }

    removeCaptureOverride(num) {
        this.saving = true;
        this.api.removeCaptureOverride(this.id, num,
            this.authService.getUser().token,
            () => {this.overrideCaptureChanged(num, false)},
            (msg) => {});

            //  this.userMessageService.setUserError("user", "remove capture")});

            //  this.userMessageService.setUserError("user", msg)});

    }

    overrideCaptureChanged(num, capture_override) {
        this.userMessageService.setUserMessage("user", "Saved!");

        this.saving = false;

        switch(num) {
            case 1:
                this.capture_override_1 = capture_override;
            break;
            case 2:
                this.capture_override_2 = capture_override;
            break;
            case 3:
                this.capture_override_3 = capture_override;
            break;
        }
      
        this.api.getFileList(
            this.id, 
            this.authService.getUser().token,
            this.getFileListSuccess.bind(this),
            (msg) => {});

            //  this.userMessageService.setUserError("user", "getfile")});

            //  this.userMessageService.setUserError("user", msg)});


    }
}
